var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.004 1.509L1.513 7.99l.906.907L7.362 3.96l-.004 10.442H8.64l.004-10.44 4.935 4.942.907-.904z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseSmall);
export default __webpack_public_path__ + "static/media/increase-small.71d19bac9d61c0654b1f954c36664100.svg";
export { ForwardRef as ReactComponent };